import popUpHtml from './popUp.html';
const sessionStorageKey = 'widgetPopUpClosed';
const defaultIntervalSeconds = 5;
const checkPopUpRules = ({ text, interval, isActive }) => {
    if (window.sessionStorage.getItem(sessionStorageKey) === 'true' ||
        isActive === false ||
        !text ||
        (typeof interval !== 'number' && interval !== null) ||
        (typeof interval === 'number' && interval < 0))
        return false;
    return true;
};
const setupWrapper = (position, openWidget) => {
    const popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-hidden');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add(`widget-popup-wrapper-${position}`);
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.addEventListener('click', () => {
        closePopUp();
        openWidget();
    });
};
const setupCloseButton = () => {
    const closeButton = document.getElementById('closePopUpButton');
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        closePopUp();
    });
};
const setupText = (title, text) => {
    var _a, _b;
    const titleSpan = document.querySelector('.widget-popup-title span');
    const textSpan = document.querySelector('.widget-popup-text span');
    const closeButton = document.getElementById('closePopUpButton');
    if (!textSpan || !closeButton)
        return;
    textSpan.textContent = text;
    if (title && titleSpan) {
        titleSpan.textContent = title;
        (_a = titleSpan.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(closeButton, titleSpan.nextSibling);
    }
    else
        (_b = textSpan.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(closeButton, textSpan.nextSibling);
};
const openPopUp = (popUpSettings) => {
    if (!checkPopUpRules(popUpSettings))
        return;
    const popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.remove('widget-popup-wrapper-hidden');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-shown');
};
export const closePopUp = () => {
    const popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.remove('widget-popup-wrapper-shown');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-hidden');
    window.sessionStorage.setItem(sessionStorageKey, 'true');
};
export const setPopUp = (popUpSettings, { appendCallback, openWidget }) => {
    const { title, text, interval, position } = popUpSettings;
    if (!checkPopUpRules(popUpSettings))
        return;
    appendCallback(popUpHtml);
    setupWrapper(position, openWidget);
    setupCloseButton();
    setupText(title, text);
    setTimeout(() => openPopUp(popUpSettings), (interval || defaultIntervalSeconds) * 1000);
};
